if (!customElements.get('fairf-viewport-video')) {
  customElements.define('fairf-viewport-video', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.video = this.querySelector('video');
      if (!this.video || !('IntersectionObserver' in window)) return;
      this.abort = new AbortController();
      const listen = (target, event, handler) => target.addEventListener(event, handler, { signal: this.abort.signal });
      this.visible = false;
      this.userPaused = false;
      this.automaticPause = false;
      this.video.muted = true;
      this.video.playsInline = true;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      listen(this.video, 'pause', () => {
        if (this.automaticPause) this.automaticPause = false;
        else if (!this.video.ended) this.userPaused = true;
      });
      listen(this.video, 'play', () => { this.userPaused = false; });
      listen(document, 'visibilitychange', () => this.sync());
      listen(this.motion, 'change', () => {
        if (this.motion.matches) this.pauseAutomatically();
        else this.sync();
      });
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting && entries[0].intersectionRatio >= .35;
        this.sync();
      }, { threshold: [0, .35] });
      this.observer.observe(this.video);
    }
    pauseAutomatically() {
      if (!this.video.paused) {
        this.automaticPause = true;
        this.video.pause();
      }
    }
    sync() {
      if (!this.visible || document.hidden) {
        this.pauseAutomatically();
      } else if (!this.motion.matches && !this.userPaused && !this.video.ended && this.video.paused) {
        // Native controls remain available if the browser declines autoplay.
        this.video.play().catch(() => {});
      }
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.abort?.abort();
      this.abort = null;
      this.video?.pause();
    }
  });
}
